import PropTypes from "prop-types";
import { useState } from "react";
import { Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";

import TextareaModalContent from "../../../Common/IleggelseClient/TextareaModalContent";
import ModalGenericPostCancelContainer from "../../../Common/ModalGenericPostCancelContainer";

import {
  getIleggelseEttersendelser as getIleggelseEttersendelserAction,
  postIleggelseEttersendelser as postIleggelseEttersendelserAction,
} from "../../../../actions/ileggelseEttersendelserActions";
import { getIleggelse as getIleggelseAction } from "../../../../actions/ileggelserActions";

import { commentHasToBeBetween } from "../../../../constants/ErrorMessages";
import {
  ettersendelsesrapportMaxLength,
  ettersendelsesrapportMinLength,
} from "../../../../constants/globals";

export default function NyEttersendelseContainer({ reloadHistorikk }) {
  const ileggelse = useSelector((state) => state.ileggelse);
  const dispatch = useDispatch();

  const [kommentar, setKommentar] = useState(null);
  const [kommentarValidationError, setKommentarValidationError] =
    useState(null);

  const getIleggelse = (id) => dispatch(getIleggelseAction(id));
  const getIleggelseEttersendelser = (id) =>
    dispatch(getIleggelseEttersendelserAction(id));
  const postIleggelseEttersendelser = (id, params) =>
    dispatch(postIleggelseEttersendelserAction(id, params));

  const validation = () =>
    kommentar &&
    kommentar.length >= ettersendelsesrapportMinLength &&
    kommentar.length <= ettersendelsesrapportMaxLength;

  const handleApiCall = async (ileggelseId) => {
    if (validation()) {
      return postIleggelseEttersendelser(ileggelseId, { kommentar })
        .then(() => {
          setKommentar(null);
          setKommentarValidationError(null);
          getIleggelse(ileggelseId);
          getIleggelseEttersendelser(ileggelseId);
          reloadHistorikk();
          return Promise.resolve();
        })
        .catch((error) => Promise.reject(error));
    } else {
      setKommentarValidationError(true);
      return Promise.reject("validationError");
    }
  };

  if (
    !ileggelse.isTilEttersendelse &&
    !ileggelse.isEttersendelseTilGodkjenning &&
    ileggelse.forsinketMakuleringStatus &&
    !ileggelse.forsinketMakuleringStatus.deletePossible &&
    !ileggelse.isMakulert &&
    !ileggelse.isBetalt &&
    ileggelse.leveringstype.id === 3
  ) {
    return (
      <ModalGenericPostCancelContainer
        id={ileggelse.id}
        modalTitle={`Ny ettersendelse av ileggelse ${ileggelse.ileggelsesnummer}`}
        submitButtonText="Lag ny ettersendelse"
        submittingButtonText="Lager ny ettersendelse..."
        successPostCallFlashMessage="Endring fullført"
        errorPostCallFlashMessage="Endring feilet"
        handleApiCall={handleApiCall}
        openModalComponentFunction={(props) => (
          <Button
            className="btn btn-bym-standard"
            style={{ marginLeft: 20 }}
            onClick={props.openModal}
          >
            Ny Ettersendelse
          </Button>
        )}
      >
        <TextareaModalContent
          paragrapghText={`Ønsker du å lage en ny ettersendelse for ileggele ${ileggelse.ileggelsesnummer}?`}
          kommentarValidationError={kommentarValidationError}
          textareaLabel="Ettersendelsesrapport"
          textareaPlaceholder="Ettersendelsesrapport"
          validationErrorText={commentHasToBeBetween(
            ettersendelsesrapportMinLength,
            ettersendelsesrapportMaxLength,
          )}
          handleChange={(e) => setKommentar(e.target.value)}
        />
      </ModalGenericPostCancelContainer>
    );
  }
  return <span />;
}

NyEttersendelseContainer.propTypes = {
  reloadHistorikk: PropTypes.func,
};
